module.exports = "/_next/static/images/aeb3d202a27e2d3f68e4aa8d1ac73153-apply-lg.jpg.webp";